import React from 'react';
import { motion } from 'framer-motion';
import { company } from '../data/content';
import { familyPhotos, familyTagline } from '../data/family';
const ease = [0.23, 1, 0.32, 1] as const;
export function StorySection() {
  const [lead, ...rest] = familyPhotos;
  return <section id="family" className="w-full bg-navy-800 py-20 lg:py-28" data-id="element-713" data-mp="bz8rl4lo5rzh">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-714" data-mp="81uhzbu2ti6y">
        <div className="grid items-center gap-12 lg:grid-cols-[minmax(0,6fr)_minmax(0,5fr)] lg:gap-16" data-id="element-715" data-mp="14qin57kp1ayy">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.3,
          ease
        }} className="grid grid-cols-2 gap-4" data-id="element-716" data-mp="zs8pmqbhxya6">
            <figure className="col-span-2 overflow-hidden rounded-lg" data-id="element-717" data-mp="3gfjmelgcuocn">
              <img src={lead.src} alt={lead.alt} className="h-[240px] w-full object-cover sm:h-[320px]" data-id="element-718" data-mp="3gdqez3xx403l" />
              <figcaption className="bg-navy-900 px-4 py-3 text-[13px] text-navy-200" data-id="element-719" data-mp="1o8zj70af5vzy">
                {lead.caption}
              </figcaption>
            </figure>

            {rest.map(photo => <figure key={photo.src} className="overflow-hidden rounded-lg" data-id="element-720" data-mp="1f6hxcmyof5dh">
                <img src={photo.src} alt={photo.alt} className="h-[150px] w-full object-cover sm:h-[190px]" data-id="element-721" data-mp="1k51k2pl3gl6w" />
                <figcaption className="bg-navy-900 px-4 py-3 text-[13px] leading-snug text-navy-200" data-id="element-722" data-mp="1a8gfg5czlc3l">
                  {photo.caption}
                </figcaption>
              </figure>)}
          </motion.div>

          <div data-id="element-723" data-mp="10j57im1u6dha">
            <div className="flex items-center gap-4" data-id="element-724" data-mp="10in1ixpdgkw6">
              <img src={company.logo} alt="" className="h-14 w-14 shrink-0 object-contain" data-id="element-725" data-mp="mhssqdyewhwz" />
              <p className="font-display text-sm font-bold uppercase tracking-[0.14em] text-sky-300" data-id="element-726" data-mp="rh5pbqf353cr">
                {familyTagline}
              </p>
            </div>

            <p className="mt-8 text-sm font-semibold text-sky-300" data-id="element-727" data-mp="2t8pfyqw3tjl3">Twenty years ago</p>
            <blockquote className="mt-3 font-display text-2xl font-bold leading-snug tracking-tight text-white sm:text-3xl" data-id="element-728" data-mp="2oel8m6ixf9jh">
              &ldquo;What if we just did pool work the way we&apos;d want it done if we were the
              customer?&rdquo;
            </blockquote>
            <div className="mt-6 space-y-4 text-lg leading-relaxed text-navy-100" data-id="element-729" data-mp="3c45scrmwmatt">
              <p data-id="element-730" data-mp="383lrpe34gp2x">
                No shortcuts. No licensing corner-cuts. No disappearing acts. No hidden fees. Just
                show up on time, do the work right, charge an honest price, and actually be there
                if someone needs us.
              </p>
              <p data-id="element-731" data-mp="1rplu49rr1biu">
                Two decades later it&apos;s still the same family on your deck — our kids grew up
                around these pools, and their name is on the shirt too.
              </p>
              <p className="font-semibold text-white" data-id="element-732" data-mp="1cmu9vl6quc47">
                That&apos;s why repeat customers, referrals, and families who come back for their
                second pool are most of our work.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}